<template>
  <van-dialog
    :show="show"
    title="Do you want to add a shortcut to your home screen for easy access?"
    cancel-button-text="Cancel"
    confirm-button-text="Add"
    show-cancel-button
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <div class="content">
      <p class="tips">Tips: Adding the shortcut won't consume any mobile data.</p>

      <van-checkbox v-model="useNeverPrompt().value">Do not remind again!</van-checkbox>
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
const { $formatDate } = useNuxtApp()

const handleConfirm = () => {
  usePWAPrompt().value.prompt()
}

const PWA_POPUP_TIME = 'pwa_popup_time'
const curTime = $formatDate(new Date(), 'yyyyMMdd')

const show = computed<boolean>(() => {
  const lastPopupTime = localStorage.getItem(PWA_POPUP_TIME)

  if(lastPopupTime === curTime) {
    return false
  }

  return !!(usePWAPromptPopup().value && usePWAPrompt().value)
})

const handleCancel = () => {
  if(useNeverPrompt().value) {
    localStorage.setItem('pwa_never_prompt', 'never')
  }

  localStorage.setItem(PWA_POPUP_TIME, curTime)
  usePWAPromptPopup().value = false
}
</script>

<style lang="scss" scoped>
.content{
  padding: 30px 40px;
  color: #666;
  .tips{
    text-align: center;
    margin-bottom: 30px;
  }
}
</style>